<template>
    <el-checkbox-group v-model="checkboxValues" @change="handleChange">
        <el-checkbox v-for="item in checkboxOptions" :label="item.value" :key="item.value" :disabled="disabled">{{ item.label }}</el-checkbox>
        <slot name="checkbox-last"></slot>
    </el-checkbox-group>
</template>
<script>
import { dictWithUrl } from '@/components/lots/api';
export default {
    props: {
        values: {
            type: Array,
            default () {
                return [];
            }
        },
        dictCode: {
            type: String,
            default () {
                return '';
            }
        },
        options: {
            type: Array,
            default () {
                return [];
            }
        },
        disabled: {
            type: Boolean,
            default () {
                return false;
            }
        }
    },
    data() {
        return {
            checkboxValues: [],
            checkboxOptions: []
        };
    },
    methods: {
        handleChange(val) {
            this.$emit('change', val);
        },
        setCheckboxOptions(dictData) {
            for (const key in dictData) {
                if (dictData[key]) {
                    this.checkboxOptions.push({
                        label: dictData[key],
                        value: key
                    });
                }
            }
        }
    },
    mounted() {
        if (this.dictCode) {
            dictWithUrl(this.dictCode).then(res => {
                if (res && +res.code === 0) {
                    this.setCheckboxOptions(res.data[this.dictCode]);
                }
            });
        } else {
            this.checkboxOptions = this.options;
        }
    },
    watch: {
        values: {
            handler(val) {
                this.checkboxValues = val;
            },
            immediate: true
        }
    }
};
</script>
